module.exports = __webpack_public_path__ + "static/img/VimeoLogo.7581177d.svg";